export const LIST_PAGE_LIMIT = 20;
export const LIST_PAGE_LIMIT_OPTIONS = [20, 50, 100, 500, 1000];
export const STATEMENT_PAGE_LIMIT = 50;

export const STATUS_CHIPS = [
  { value: "", label: "All" },
  { value: "ACTIVE", label: "Active" },
  { value: "COMPLETED", label: "Completed" },
  { value: "CANCELLED", label: "Cancelled" },
];

export const FIELD_HELP = {
  staked: "User ne kitna lock kiya",
  expected_return: "Poori life me wallet me total kitna jaana chahiye (principal + profit)",
  interest_total: "Uper ka profit = expected return − staked",
  payout_paid: "Wallet me actually credit ho chuka payout",
  payout_remaining: "ACTIVE plan pe abhi jana baaki (future profit + last principal)",
  interest_paid: "Uper wale profit me se kitna nikal chuka",
  interest_remaining: "Profit me se kitna baaki",
  principal_paid: "Principal wapas mil chuka",
  principal_remaining: "Principal abhi lock",
  payout_forfeited: "Cancel ke baad jo ROI nahi jayega",
  refunded: "Cancel pe principal refund",
  cancel_fee: "Cancel fee",
};

export const TYPE_BADGE = {
  STAKE: { label: "Stake", kind: "grey" },
  PAYOUT: { label: "Payout", kind: "green" },
  CANCEL_FEE: { label: "Cancel fee", kind: "red" },
  REFUND: { label: "Refund", kind: "blue" },
};

export const LINE_STATUS_BADGE = {
  posted: { label: "Posted", kind: "grey" },
  paid: { label: "Paid", kind: "green" },
  pending: { label: "Upcoming", kind: "orange" },
  forfeited: { label: "Forfeited", kind: "red" },
};

export const PLAN_STATUS_KIND = {
  ACTIVE: "green",
  COMPLETED: "blue",
  CANCELLED: "red",
};

export const PAYOUT_TYPE_LABEL = {
  profit: "Interest",
  "profit + principal": "Interest + principal",
  return: "Return",
};

export const asNum = (v) => {
  if (v == null || v === "") return 0;
  if (typeof v === "object" && v.$numberDecimal != null) {
    const n = Number(v.$numberDecimal);
    return Number.isFinite(n) ? n : 0;
  }
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

export const hasPositive = (v) => asNum(v) > 0;

export const formatMoney = (v, currency, { min = 2, max = 8 } = {}) => {
  if (v == null || v === "") return currency ? `— ${currency}` : "—";
  const n = asNum(v);
  const formatted = n.toLocaleString("en-IN", {
    minimumFractionDigits: min,
    maximumFractionDigits: max,
  });
  return currency ? `${formatted} ${currency}` : formatted;
};

export const formatMoneyList = (v, currency) => formatMoney(v, currency, { min: 0, max: 8 });

export const userDisplayName = (user) => {
  if (!user) return "—";
  const parts = [user.first_name, user.last_name].filter(Boolean);
  if (parts.length) return parts.join(" ");
  return user.email || user.uuid || "—";
};

export const formatDateShort = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return String(iso);
  }
};

export const formatDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  } catch {
    return String(iso);
  }
};

export const dateToFromIso = (d) => (d ? `${d}T00:00:00.000Z` : undefined);
export const dateToToIso = (d) => (d ? `${d}T23:59:59.999Z` : undefined);

export const packageOptionLabel = (pkg) => {
  const cur = pkg?.currency ?? pkg?.currency_short_name ?? pkg?.short_name ?? "";
  const days = pkg?.duration_days != null ? `${pkg.duration_days}d` : "";
  const pct = pkg?.return_percentage != null ? `${pkg.return_percentage}%` : "";
  return [cur, days, pct].filter(Boolean).join(" · ") || pkg?._id || "Package";
};

export const coinOptionLabel = (c) => {
  const shortName = c.short_name || c.currency || "";
  const name = c.name || c.fullname || "";
  if (shortName && name && name !== shortName) return `${shortName} — ${name}`;
  return shortName || name || c._id || c.id;
};

export const subscriptionShortId = (id) => {
  const s = String(id || "");
  return s.length > 6 ? s.slice(-6) : s;
};

export const payoutTypeLabel = (value) => {
  if (!value) return "";
  return PAYOUT_TYPE_LABEL[value] || String(value);
};

export const isMongoId = (value) => /^[a-fA-F0-9]{24}$/.test(String(value || ""));

export const isUnauthorized = (res) => {
  const status = Number(res?.httpStatus);
  if (status === 401) return true;
  const msg = String(res?.message || "").toLowerCase();
  return msg.includes("unauthorized") || msg.includes("jwt") || msg.includes("token is expired");
};

export const copyText = async (text) => {
  const value = String(text || "");
  if (!value) return false;
  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch {
    return false;
  }
};
